@if (field.multiple) {
    <mat-form-field class="w-100" [subscriptSizing]="hideMatHint ? 'dynamic' : 'fixed'">
        <mat-label>{{ field.name }}</mat-label>

        <mat-select [formControl]="fc" [placeholder]="field.name" [multiple]="field.multiple">
            @if (selectedOptions) {
                <mat-select-trigger>
                    {{ selectedOptions }}
                </mat-select-trigger>
            }

            <mat-option *ngFor="let option of field.options" [value]="option.key">
                {{ option.name }}
            </mat-option>
        </mat-select>

        <mat-error [control]="fc"></mat-error>
    </mat-form-field>
} @else {
    <div [ngClass]="{ 'mat-ng-select': !tableStyle, 'd-flex': tableStyle }">
        <ng-select
            class="select-input"
            [class.ng-select-fill]="!tableStyle"
            [class.invalid]="fc.invalid"
            [formControl]="fc"
            [placeholder]="field.name">
            @for (option of field.options; track option.key) {
                <ng-option [value]="option.key">
                    {{ option.name }}
                </ng-option>
            }
        </ng-select>

        <mat-error [control]="fc"></mat-error>
    </div>
}
